import { selectIn } from 'common/util/selector'

const base = (state, props) => state.auth.sso

export const ssoAuthorizationUrl = selectIn(base, 'sso_authorization_url')
